import Stack from "@mui/material/Stack";
import Buttons from "./Buttons";

const CONVERSION_FACTORS = {
  Imperial: {
    Metric: {
      dimension: 2.54,
      weight: 1 / 2.205,
    },
  },
  Metric: {
    Imperial: {
      dimension: 1 / 2.54,
      weight: 2.205,
    },
  },
};

const convertValue = (value, factor) => {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  const number = Number(value);

  return Number.isFinite(number) ? (number * factor).toFixed(2) : "";
};

export default function UnitSwitch({ List, SetList, SetPlist }) {
  const handletype = (e) => {
    const newUnit = e.target.name;
    const currentUnit = List?.unit;

    if (!currentUnit || currentUnit === newUnit) {
      return;
    }

    const conversion = CONVERSION_FACTORS[currentUnit]?.[newUnit];

    if (!conversion) {
      return;
    }

    SetPlist((prevState) =>
      prevState.map((item) => ({
        ...item,
        length: convertValue(item.length, conversion.dimension),
        height: convertValue(item.height, conversion.dimension),
        width: convertValue(item.width, conversion.dimension),
        weight: convertValue(item.weight, conversion.weight),
      })),
    );

    SetList((prev) => ({
      ...prev,
      unit: newUnit,
      QuoteCheck: false,
    }));
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
    >
      {["Imperial", "Metric"].map((unit) => (
        <Buttons
          key={unit}
          Name={unit}
          HandleChange={handletype}
          Variant={List?.unit === unit ? "contained" : "outlined"}
          Color={List?.unit === unit ? "primary" : "inherit"}
        />
      ))}
    </Stack>
  );
}
